// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Sort bar — visible only on mobile ──────────────────────────────────── */

.driver-sessions-sort-bar {
  display: none;
  align-items: center;
  gap: 8px;
  padding: 8px 0 4px;
}

.driver-sessions-sort-label {
  font-size: 12px;
  color: var(--muted, #94a3b8);
  white-space: nowrap;
}

.driver-sessions-sort-select {
  flex: 1 1;
  width: auto;
  border: 1px solid var(--border, #334155);
  border-radius: 6px;
  padding: 5px 8px;
  background: var(--surface, #0f172a);
  color: var(--text, #e2e8f0);
  font-size: 12px;
}

/* ─── Session cell — shared desktop + mobile ─────────────────────────────── */

.ds-session-group {
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
  min-width: 0;
}

.ds-session-name {
  color: var(--text, #f1f5f9);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.ds-session-buttons {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.ds-session-type-btn {
  background: var(--surface, #0f172a);
  border: 1px solid var(--border, #334155);
  border-radius: 5px;
  padding: 1px 6px;
  cursor: pointer;
  font: inherit;
  font-size: 11px;
  font-weight: 700;
  color: var(--text, #e2e8f0);
  line-height: 1.6;
  transition: background 0.15s, color 0.15s;
}

.ds-session-type-btn:hover {
  background: var(--button-bg, #4f46e5);
  color: var(--button-text, #fff);
  border-color: var(--button-border, #4f46e5);
}

/* Mobile-only buttons cell: hidden by default, shown in mobile grid */
.ds-buttons-cell {
  display: none;
}

/* ─── Mobile layout ──────────────────────────────────────────────────────── */

@media (max-width: 768px) {
  .driver-sessions-sort-bar {
    display: flex;
  }

  .table-wrapper .driver-sessions-table thead {
    display: none;
  }

  .table-wrapper .driver-sessions-table,
  .table-wrapper .driver-sessions-table tbody {
    display: block;
    width: 100%;
  }

  /*
   * 2-column × 3-row grid:
   *
   *   col 1 (1fr)       col 2 (auto)
   *   ─────────────────────────────────
   *   session name      best lap        row 1
   *   track name        car             row 2
   *   result buttons    date            row 3
   *
   * td order: 1=session, 2=track, 3=car, 4=bestLap, 5=date, 6=ds-buttons-cell
   */
  .table-wrapper .driver-sessions-table tr {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto auto;
    column-gap: 8px;
    row-gap: 0;
    padding: 7px 10px;
    border: none;
    border-bottom: 1px solid #1e293b;
    background: transparent;
    margin: 0;
    border-radius: 0;
    align-items: start;
    cursor: pointer;
  }

  .table-wrapper .driver-sessions-table tbody tr:first-child {
    border-top: 1px solid #1e293b;
  }

  .table-wrapper .driver-sessions-table tbody tr[style*="cursor: default"] {
    cursor: default;
  }

  .table-wrapper .driver-sessions-table td {
    padding: 0;
    border: none;
    font-size: 13px;
    line-height: 1.4;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  /* td 1: session name — row 1, col 1 */
  .table-wrapper .driver-sessions-table td:nth-child(1) {
    grid-column: 1;
    grid-row: 1;
    min-width: 0;
    overflow: hidden;
  }

  .table-wrapper .driver-sessions-table td:nth-child(1) .ds-session-group {
    display: block;
    overflow: hidden;
  }

  .table-wrapper .driver-sessions-table td:nth-child(1) .ds-session-name {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 600;
    color: #f1f5f9;
  }

  /* Hide inline desktop buttons inside td 1 */
  .table-wrapper .driver-sessions-table td:nth-child(1) .ds-buttons-desktop {
    display: none;
  }

  /* td 2: track — row 2, col 1 */
  .table-wrapper .driver-sessions-table td:nth-child(2) {
    grid-column: 1;
    grid-row: 2;
    font-size: 11px;
    color: #64748b;
    padding-top: 1px;
  }

  .table-wrapper .driver-sessions-table td:nth-child(2) span {
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  /* td 3: car — row 2, col 2 */
  .table-wrapper .driver-sessions-table td:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
    text-align: right;
    font-size: 11px;
    color: #64748b;
    white-space: nowrap;
    padding-top: 1px;
  }

  /* td 4: best lap — row 1, col 2 */
  .table-wrapper .driver-sessions-table td:nth-child(4) {
    grid-column: 2;
    grid-row: 1;
    text-align: right;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    padding-top: 1px;
  }

  /* td 5: date — row 3, col 2 */
  .table-wrapper .driver-sessions-table td:nth-child(5) {
    grid-column: 2;
    grid-row: 3;
    text-align: right;
    font-size: 10px;
    color: #475569;
    padding-top: 3px;
    white-space: nowrap;
    overflow: visible;
  }

  /* td 6: mobile buttons cell — row 3, col 1 */
  .table-wrapper .driver-sessions-table td.ds-buttons-cell {
    display: block;
    grid-column: 1;
    grid-row: 3;
    padding-top: 3px;
    overflow: visible;
    white-space: normal;
  }
}

/* ─── Light theme ────────────────────────────────────────────────────────── */

body.light-theme .table-wrapper .driver-sessions-table tr {
  border-bottom-color: var(--border);
}

body.light-theme .table-wrapper .driver-sessions-table tbody tr:first-child {
  border-top-color: var(--border);
}

body.light-theme .table-wrapper .driver-sessions-table td:nth-child(1) .ds-session-name {
  color: var(--text);
}

body.light-theme .table-wrapper .driver-sessions-table td:nth-child(2),
body.light-theme .table-wrapper .driver-sessions-table td:nth-child(3) {
  color: var(--muted);
}

body.light-theme .table-wrapper .driver-sessions-table td:nth-child(5) {
  color: var(--muted);
}
`, "",{"version":3,"sources":["webpack://./src/pages/DriverDetailPage.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA,sEAAsE;AACtE;EACE,aAAa;AACf;;AAEA,+EAA+E;;AAE/E;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;IACd,WAAW;EACb;;EAEA;;;;;;;;;;IAUE;EACF;IACE,aAAa;IACb,+BAA+B;IAC/B,kCAAkC;IAClC,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA,4CAA4C;EAC5C;IACE,aAAa;EACf;;EAEA,+BAA+B;EAC/B;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;EAChB;;EAEA,6BAA6B;EAC7B;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,kCAAkC;EAClC;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA,6CAA6C;EAC7C;IACE,cAAc;IACd,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,+EAA+E;;AAE/E;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ─── Sort bar — visible only on mobile ──────────────────────────────────── */\r\n\r\n.driver-sessions-sort-bar {\r\n  display: none;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 0 4px;\r\n}\r\n\r\n.driver-sessions-sort-label {\r\n  font-size: 12px;\r\n  color: var(--muted, #94a3b8);\r\n  white-space: nowrap;\r\n}\r\n\r\n.driver-sessions-sort-select {\r\n  flex: 1;\r\n  width: auto;\r\n  border: 1px solid var(--border, #334155);\r\n  border-radius: 6px;\r\n  padding: 5px 8px;\r\n  background: var(--surface, #0f172a);\r\n  color: var(--text, #e2e8f0);\r\n  font-size: 12px;\r\n}\r\n\r\n/* ─── Session cell — shared desktop + mobile ─────────────────────────────── */\r\n\r\n.ds-session-group {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n  min-width: 0;\r\n}\r\n\r\n.ds-session-name {\r\n  color: var(--text, #f1f5f9);\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  min-width: 0;\r\n}\r\n\r\n.ds-session-buttons {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.ds-session-type-btn {\r\n  background: var(--surface, #0f172a);\r\n  border: 1px solid var(--border, #334155);\r\n  border-radius: 5px;\r\n  padding: 1px 6px;\r\n  cursor: pointer;\r\n  font: inherit;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  color: var(--text, #e2e8f0);\r\n  line-height: 1.6;\r\n  transition: background 0.15s, color 0.15s;\r\n}\r\n\r\n.ds-session-type-btn:hover {\r\n  background: var(--button-bg, #4f46e5);\r\n  color: var(--button-text, #fff);\r\n  border-color: var(--button-border, #4f46e5);\r\n}\r\n\r\n/* Mobile-only buttons cell: hidden by default, shown in mobile grid */\r\n.ds-buttons-cell {\r\n  display: none;\r\n}\r\n\r\n/* ─── Mobile layout ──────────────────────────────────────────────────────── */\r\n\r\n@media (max-width: 768px) {\r\n  .driver-sessions-sort-bar {\r\n    display: flex;\r\n  }\r\n\r\n  .table-wrapper .driver-sessions-table thead {\r\n    display: none;\r\n  }\r\n\r\n  .table-wrapper .driver-sessions-table,\r\n  .table-wrapper .driver-sessions-table tbody {\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  /*\r\n   * 2-column × 3-row grid:\r\n   *\r\n   *   col 1 (1fr)       col 2 (auto)\r\n   *   ─────────────────────────────────\r\n   *   session name      best lap        row 1\r\n   *   track name        car             row 2\r\n   *   result buttons    date            row 3\r\n   *\r\n   * td order: 1=session, 2=track, 3=car, 4=bestLap, 5=date, 6=ds-buttons-cell\r\n   */\r\n  .table-wrapper .driver-sessions-table tr {\r\n    display: grid;\r\n    grid-template-columns: 1fr auto;\r\n    grid-template-rows: auto auto auto;\r\n    column-gap: 8px;\r\n    row-gap: 0;\r\n    padding: 7px 10px;\r\n    border: none;\r\n    border-bottom: 1px solid #1e293b;\r\n    background: transparent;\r\n    margin: 0;\r\n    border-radius: 0;\r\n    align-items: start;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .table-wrapper .driver-sessions-table tbody tr:first-child {\r\n    border-top: 1px solid #1e293b;\r\n  }\r\n\r\n  .table-wrapper .driver-sessions-table tbody tr[style*=\"cursor: default\"] {\r\n    cursor: default;\r\n  }\r\n\r\n  .table-wrapper .driver-sessions-table td {\r\n    padding: 0;\r\n    border: none;\r\n    font-size: 13px;\r\n    line-height: 1.4;\r\n    display: block;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    min-width: 0;\r\n  }\r\n\r\n  /* td 1: session name — row 1, col 1 */\r\n  .table-wrapper .driver-sessions-table td:nth-child(1) {\r\n    grid-column: 1;\r\n    grid-row: 1;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .table-wrapper .driver-sessions-table td:nth-child(1) .ds-session-group {\r\n    display: block;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .table-wrapper .driver-sessions-table td:nth-child(1) .ds-session-name {\r\n    display: block;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: #f1f5f9;\r\n  }\r\n\r\n  /* Hide inline desktop buttons inside td 1 */\r\n  .table-wrapper .driver-sessions-table td:nth-child(1) .ds-buttons-desktop {\r\n    display: none;\r\n  }\r\n\r\n  /* td 2: track — row 2, col 1 */\r\n  .table-wrapper .driver-sessions-table td:nth-child(2) {\r\n    grid-column: 1;\r\n    grid-row: 2;\r\n    font-size: 11px;\r\n    color: #64748b;\r\n    padding-top: 1px;\r\n  }\r\n\r\n  .table-wrapper .driver-sessions-table td:nth-child(2) span {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n  }\r\n\r\n  /* td 3: car — row 2, col 2 */\r\n  .table-wrapper .driver-sessions-table td:nth-child(3) {\r\n    grid-column: 2;\r\n    grid-row: 2;\r\n    text-align: right;\r\n    font-size: 11px;\r\n    color: #64748b;\r\n    white-space: nowrap;\r\n    padding-top: 1px;\r\n  }\r\n\r\n  /* td 4: best lap — row 1, col 2 */\r\n  .table-wrapper .driver-sessions-table td:nth-child(4) {\r\n    grid-column: 2;\r\n    grid-row: 1;\r\n    text-align: right;\r\n    font-family: 'Courier New', monospace;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    padding-top: 1px;\r\n  }\r\n\r\n  /* td 5: date — row 3, col 2 */\r\n  .table-wrapper .driver-sessions-table td:nth-child(5) {\r\n    grid-column: 2;\r\n    grid-row: 3;\r\n    text-align: right;\r\n    font-size: 10px;\r\n    color: #475569;\r\n    padding-top: 3px;\r\n    white-space: nowrap;\r\n    overflow: visible;\r\n  }\r\n\r\n  /* td 6: mobile buttons cell — row 3, col 1 */\r\n  .table-wrapper .driver-sessions-table td.ds-buttons-cell {\r\n    display: block;\r\n    grid-column: 1;\r\n    grid-row: 3;\r\n    padding-top: 3px;\r\n    overflow: visible;\r\n    white-space: normal;\r\n  }\r\n}\r\n\r\n/* ─── Light theme ────────────────────────────────────────────────────────── */\r\n\r\nbody.light-theme .table-wrapper .driver-sessions-table tr {\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .table-wrapper .driver-sessions-table tbody tr:first-child {\r\n  border-top-color: var(--border);\r\n}\r\n\r\nbody.light-theme .table-wrapper .driver-sessions-table td:nth-child(1) .ds-session-name {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .table-wrapper .driver-sessions-table td:nth-child(2),\r\nbody.light-theme .table-wrapper .driver-sessions-table td:nth-child(3) {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .table-wrapper .driver-sessions-table td:nth-child(5) {\r\n  color: var(--muted);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
